import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { NetworkService } from "../service/network.service";
import { Router, RouterModule } from '@angular/router';
import { HasRolesDirective } from 'keycloak-angular';
import { TranslationService } from '../service/translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [TranslationService],
  imports: [CommonModule, RouterModule, HasRolesDirective, TranslateModule],
  standalone: true
})
export class HomeComponent implements OnInit, OnDestroy {
  logoEquipe = "../assets/images/home/logoEquipeDIP.svg";
  logoWorldline = "../assets/images/home/logoWorldline.svg";
  chemimagecard = "../assets/images/home/card/";
  mainFeatures: { label: string, route: string, role: string }[] = [
    { label: "Compromise Reports", route: "compromise-reports", role: "bo-dip-policy-violations-viewer" },
    { label: "Attestations", route: "attestations", role: "bo-dip-attestations-viewer" },
    { label: "Security Policies", route: "security-policies", role: "bo-dip-security-policies-viewer" },
    { label: "Settings", route: "settings", role: "bo-dip-wl-admin" }
  ];

  private readonly translationService = inject(TranslationService);
  private readonly keycloak = inject(Keycloak);
  accessibleCount = signal(0);

  constructor(
    public networkService: NetworkService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
   
    this.translationService.get('home').subscribe((translation) => {
      document.title = `DIP - ${translation}`;
    });
    document.body.style.backgroundColor = "#46BEAA";
    const accessible = this.mainFeatures.filter(feature =>
      this.hasRole(feature.role)
    );
    if (accessible.length === 1) {
      this.router.navigate([accessible[0].route]);
    }

  }

  hasRole(role: string): boolean {
    return this.keycloak.hasRealmRole(role);
  }

  ngOnDestroy(): void {
    document.body.style.backgroundColor = "white";
  }
}
